import { createReducer } from "@reduxjs/toolkit";
import { HousingsActionCreator } from "./housingsActions.ts";

const initialState = {
    // --- Жилая ---
    flats: {
        pending: true,
        error: false,
        data: null,
    },
    housings: {
        pending: true,
        error: false,
        data: null,
    },
    housingPricesByFirstPayment: {
        pending: false,
        error: false,
        data: null,
    },
    housingPricesByPeriod: {
        pending: false,
        error: false,
        data: null,
    },
    installmentPlanTypes: {
        pending: false,
        error: false,
        data: null,
    },

    // --- Коммерческая ---
    commerceHousings: {
        pending: true,
        error: false,
        data: null,
    },
    commercePricesByFirstPayment: {
        pending: false,
        error: false,
        data: null,
    },
    commercePricesByPeriod: {
        pending: false,
        error: false,
        data: null,
    },
    commerceInstallmentPlanTypes: {
        pending: false,
        error: false,
        data: null,
    },

    // --- Shared / Sharing ---
    sharedData: {
        pending: true,
        error: false,
        data: null,
    },
    sharingData: {
        pending: false,
        error: false,
        id: null,
        code: null,
    },
};

export const housingsReducer = createReducer(initialState, (builder) => {
    builder
        // --- Жилая ---
        .addCase(HousingsActionCreator.fetchFlatsTable.pending, (state) => {
            state.flats.pending = true;
        })
        .addCase(HousingsActionCreator.fetchFlatsTable.fulfilled, (state, action) => {
            state.flats.pending = false;
            state.flats.error = false;
            state.flats.data = action.payload;
        })
        .addCase(HousingsActionCreator.fetchFlatsTable.rejected, (state) => {
            state.flats.pending = false;
            state.flats.error = true;
        })

        .addCase(HousingsActionCreator.fetchHousings.pending, (state) => {
            state.housings.pending = true;
        })
        .addCase(HousingsActionCreator.fetchHousings.fulfilled, (state, action) => {
            state.housings.pending = false;
            state.housings.error = false;
            state.housings.data = action.payload;
        })
        .addCase(HousingsActionCreator.fetchHousings.rejected, (state) => {
            state.housings.pending = false;
            state.housings.error = true;
        })

        .addCase(HousingsActionCreator.fetchInstallmentPlanTypes.pending, (state) => {
            state.installmentPlanTypes.pending = true;
        })
        .addCase(HousingsActionCreator.fetchInstallmentPlanTypes.fulfilled, (state, action) => {
            state.installmentPlanTypes.pending = false;
            state.installmentPlanTypes.error = false;
            state.installmentPlanTypes.data = action.payload;
        })
        .addCase(HousingsActionCreator.fetchInstallmentPlanTypes.rejected, (state) => {
            state.installmentPlanTypes.pending = false;
            state.installmentPlanTypes.error = true;
        })

        .addCase(HousingsActionCreator.fetchPricesByFirstPayment.pending, (state) => {
            state.housingPricesByFirstPayment.pending = true;
        })
        .addCase(HousingsActionCreator.fetchPricesByFirstPayment.fulfilled, (state, action) => {
            state.housingPricesByFirstPayment.pending = false;
            state.housingPricesByFirstPayment.error = false;
            state.housingPricesByFirstPayment.data = action.payload;
        })
        .addCase(HousingsActionCreator.fetchPricesByFirstPayment.rejected, (state) => {
            state.housingPricesByFirstPayment.pending = false;
            state.housingPricesByFirstPayment.error = true;
        })

        .addCase(HousingsActionCreator.fetchPricesByPeriod.pending, (state) => {
            state.housingPricesByPeriod.pending = true;
        })
        .addCase(HousingsActionCreator.fetchPricesByPeriod.fulfilled, (state, action) => {
            state.housingPricesByPeriod.pending = false;
            state.housingPricesByPeriod.error = false;
            state.housingPricesByPeriod.data = action.payload;
        })
        .addCase(HousingsActionCreator.fetchPricesByPeriod.rejected, (state) => {
            state.housingPricesByPeriod.pending = false;
            state.housingPricesByPeriod.error = true;
        })

        // --- Коммерческая ---
        .addCase(HousingsActionCreator.fetchCommerceHousings.pending, (state) => {
            state.commerceHousings.pending = true;
        })
        .addCase(HousingsActionCreator.fetchCommerceHousings.fulfilled, (state, action) => {
            state.commerceHousings.pending = false;
            state.commerceHousings.error = false;
            state.commerceHousings.data = action.payload;
        })
        .addCase(HousingsActionCreator.fetchCommerceHousings.rejected, (state) => {
            state.commerceHousings.pending = false;
            state.commerceHousings.error = true;
        })

        .addCase(HousingsActionCreator.fetchCommerceInstallmentPlanTypes.pending, (state) => {
            state.commerceInstallmentPlanTypes.pending = true;
        })
        .addCase(
            HousingsActionCreator.fetchCommerceInstallmentPlanTypes.fulfilled,
            (state, action) => {
                state.commerceInstallmentPlanTypes.pending = false;
                state.commerceInstallmentPlanTypes.error = false;
                state.commerceInstallmentPlanTypes.data = action.payload;
            },
        )
        .addCase(HousingsActionCreator.fetchCommerceInstallmentPlanTypes.rejected, (state) => {
            state.commerceInstallmentPlanTypes.pending = false;
            state.commerceInstallmentPlanTypes.error = true;
        })

        .addCase(HousingsActionCreator.fetchCommercePricesByFirstPayment.pending, (state) => {
            state.commercePricesByFirstPayment.pending = true;
        })
        .addCase(
            HousingsActionCreator.fetchCommercePricesByFirstPayment.fulfilled,
            (state, action) => {
                state.commercePricesByFirstPayment.pending = false;
                state.commercePricesByFirstPayment.error = false;
                state.commercePricesByFirstPayment.data = action.payload;
            },
        )
        .addCase(HousingsActionCreator.fetchCommercePricesByFirstPayment.rejected, (state) => {
            state.commercePricesByFirstPayment.pending = false;
            state.commercePricesByFirstPayment.error = true;
        })

        .addCase(HousingsActionCreator.fetchCommercePricesByPeriod.pending, (state) => {
            state.commercePricesByPeriod.pending = true;
        })
        .addCase(
            HousingsActionCreator.fetchCommercePricesByPeriod.fulfilled,
            (state, action) => {
                state.commercePricesByPeriod.pending = false;
                state.commercePricesByPeriod.error = false;
                state.commercePricesByPeriod.data = action.payload;
            },
        )
        .addCase(HousingsActionCreator.fetchCommercePricesByPeriod.rejected, (state) => {
            state.commercePricesByPeriod.pending = false;
            state.commercePricesByPeriod.error = true;
        })

        // --- Shared / Sharing ---
        .addCase(HousingsActionCreator.fetchSharedData.pending, (state) => {
            state.sharedData.pending = true;
        })
        .addCase(HousingsActionCreator.fetchSharedData.fulfilled, (state, action) => {
            state.sharedData.pending = false;
            state.sharedData.error = false;
            state.sharedData.data = action.payload.data;
        })
        .addCase(HousingsActionCreator.fetchSharedData.rejected, (state) => {
            state.sharedData.pending = false;
            state.sharedData.error = true;
        })

        .addCase(HousingsActionCreator.fetchSharingDataId.pending, (state) => {
            state.sharingData.pending = true;
        })
        .addCase(HousingsActionCreator.fetchSharingDataId.fulfilled, (state, action) => {
            state.sharingData.pending = false;
            state.sharingData.error = false;
            state.sharingData.id = action.payload.data.id;     // DB id
            state.sharingData.code = action.payload.data.code; // короткий код
        })
        .addCase(HousingsActionCreator.fetchSharingDataId.rejected, (state) => {
            state.sharingData.pending = false;
            state.sharingData.error = true;
        })
        .addCase(HousingsActionCreator.sharingDataIdReset, (state) => {
            state.sharingData.id = null;
            state.sharingData.code = null;
        });
});
